var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grades-empty_state"},[_c('img',{staticClass:"grades-empty_state__icon",attrs:{"aria-hidden":"true","alt":"","src":require("@/assets/images/notebook-pana.svg")}}),_c('p',{staticClass:"grades-empty_state__description"},[_vm._v("\n    W tym miejscu za kilka dni pojawią się informacje o ocenach Twojego dziecka\n  ")])])
}]

export { render, staticRenderFns }